/**
 * Export-failure messaging (ADR-038 Phase I).
 *
 * Its own module so :file:`query-export.tsx` exports only components
 * (react-refresh/only-export-components), the same split
 * :file:`audit-display.ts` uses for the audit panel.
 */
import { ApiError } from "@/lib/api-client";

/**
 * The operator-facing reason an export failed.
 *
 * The over-cap rejection is the case that matters and the BFF explains it
 * precisely (how many records, what the cap is, what to do); anything else
 * falls back to a generic message rather than leaking internals
 * (REQ-UI-037).
 */
export function exportErrorMessage(caught: unknown): string {
  if (caught instanceof ApiError && caught.status === 400) {
    const body = caught.body;
    const detail =
      typeof body === "object" && body !== null
        ? ((body as Record<string, unknown>).detail as Record<string, unknown> | undefined)
        : undefined;
    const message = detail?.message;
    if (typeof message === "string") return message;
  }
  return "Could not export these results.";
}
